// @ts-nocheck
import { createSelector } from 'reselect';
import { map, omit, any, all, filter, compose } from 'ramda';
import * as R from 'ramda';
import { diffInSeconds } from '@nextinq/domain';

type DeviceStatusCode = 'ok' | 'warn' | 'error' | 'unknown';
type DeviceType = 'cloud-qsrv' | 'kiosk' | 'booth' | 'display';

type DeviceStatusCheck = {
  status: DeviceStatusCode;
  name: string;
  reason: string;
};

type DeviceStatus = {
  deviceUUID: string;
  deviceType: DeviceType;
  deviceSubType: string;
  lastUpdated: string;
  connectionStatus: 'connected' | 'disconnected';
  finalStatus: DeviceStatusCode;
  checks: Array<DeviceStatusCheck>;
};

type SourceDeviceStatus = {
  deviceUUID: string;
  deviceType: DeviceType;
  deviceSubType: string;
  lastUpdated: string;
  status?: {};
  checks: {
    errors: [];
    warnings: [];
  };
};

function evalConnectionStatus(lastUpdated) {
  if (!lastUpdated) {
    return 'disconnected';
  }
  return diffInSeconds(lastUpdated) < 60 ? 'connected' : 'disconnected';
}

const deviceStatuses = (state) => state.app.deviceStatuses;

function evalFinalStatus(result) {
  if (!result.isConnected || !R.isEmpty(result.checks.errors)) {
    return 'error';
  }
  if (!R.isEmpty(result.checks.warnings)) {
    return 'warn';
  }
  return 'ok';
}

function deviceStatusMapper(sourceStatus: SourceDeviceStatus): DeviceStatus {
  const result = omit(['status'], sourceStatus);
  result.isConnected =
    evalConnectionStatus(sourceStatus.lastUpdated) === 'connected';
  result.checks = R.path(['status', 'checks'], sourceStatus) || {
    errors: [],
    warnings: []
  };
  result.finalStatus = evalFinalStatus(result);
  return result;
}

function deviceStatusesMapper(statuses) {
  const items = compose(
    map(deviceStatusMapper),
    filter((s) => s.deviceType !== 'booth')
  )(statuses);
  const finalStatus = any((s) => s.finalStatus === 'error')(items)
    ? 'error'
    : any((s) => s.finalStatus === 'warn')(items)
    ? 'warn'
    : 'ok';
  const allConnected = all((s) => s.isConnected)(items);
  return {
    items,
    finalStatus,
    allConnected
  };
}

export const deviceStatusesSelector: Array<DeviceStatus> = createSelector(
  deviceStatuses,
  deviceStatusesMapper
);
